<template>
  <div class="interaction">
    <mainPage  :menus="menus"
               pageTitle="互动交流"
               :propActiveMenu.sync="activeMenu">
      <el-card>
        <myTable :tagData="tagData"
                 :tabData="tabData">
          <template slot="type" slot-scope="prop">
            <span>{{getSelectDesc(prop.row.type, enumeration.exhibitionTypes, 'value', 'label')}}</span>
          </template>

          <template slot="priority" slot-scope="prop">
            <span>{{getSelectDesc(prop.row.priority, enumeration.prioritys, 'value', 'label')}}</span>
          </template>
        </myTable>
        <el-pagination background
                       :page-size="pageSize"
                       :page-count="pageCount"
                       layout="prev, pager, next, total"
                       :total="total"
                       style="text-align: center;margin-top: 10px">
      </el-pagination>
      </el-card>
    </mainPage>
  </div>
</template>

<script>
import mainPage from './layout/main-page'
import myTable from './components/table'
import {enumeration} from '@/assets/js/enumeration.js'

export default {
  name: 'interaction',
  components: { 
    mainPage,
    myTable
  },
  data () {
    return {
      enumeration,
      pageSize: 10,
      pageCount: 1,
      total: 10,
      activeMenu: '1',
      menus: [
        {value: '1', label: '展会通知', path: '/interaction'},
        {value: '2', label: '联盟咨询', path: '/consulting'},
      ],
      tabData: [],
      tagData: [
        {
          prop: 'bizDate',
          label: '时间',
          widths: 140
        },
        {
          prop: 'name',
          label: '展会名称',
          widths: 160
        },
        {
          prop: 'location',
          label: '地点',
          widths: 80
        },
        {
          prop: 'organizer',
          label: '主办方',
          widths: 140
        },
        {
          prop: 'type',
          label: '类型',
          widths: 100,
          slot: true
        },
        {
          prop: 'priority',
          label: '优先级',
          widths: 100,
          slot: true
        }
      ],
    }
  },
  filters: {
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
  },
  mounted () {
    this.handleMainMenu()
  },
  methods: {
    handleMainMenu (val) {
      this.loadState = true
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/exhibition/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 10,
          data: {
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.tabData = res.data.result.list || []
        }
      }).finally(() => {
        this.loadState = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.interaction{
  .title{
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }
  .content{
    line-height: 28px;
    color: #505050;
    img{
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/interaction.vue